import React from 'react';

import ApiSelectInput from '~/components/ApiSelectInput';

import {useCategoriesList} from '../hooks';

interface Category {
  id: string;
  name: string;
}

interface CategorySelectInputProps {
  name?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  error?: boolean;
  placeholder?: string;
  testId?: string;
  fullWidth?: boolean;
}

const CategorySelectInput: React.FC<CategorySelectInputProps> = props => {
  return (
    <ApiSelectInput<Category>
      {...props}
      useDataHook={useCategoriesList}
      getItemValue={item => item.id}
      getItemLabel={item => item.name}
    />
  );
};

export default CategorySelectInput;
